{
  "$schema": "../extension_schema.json",
  "name": "notes",
  "enabled": true,
  "contextCharacteristics": [
    {
      "kind": "Capsule",
      "proxyKind": "selected",
      "eventTimeRepresentation": "capsule"
    },
    {
      "kind": "Condition",
      "proxyKind": "selected"
    }
  ],
  "uiConfig": {}
}
